<script>
    import HeaderBar from "./HeaderBar.svelte";
    import Content from "./Content.svelte";

</script>

<div class="page">
    <HeaderBar/>
    <Content/>
</div>

<style>
    @media screen and (max-width: 840px) {
        .page {
            font-size: .65rem;
        }
    }

    :global(html) {
        color: var(--theme-colors-text, initial)
    }
</style>